import { FunctionComponent } from 'react';

type BulkStatusMaxSizeErrorMessageProps = {
    readonly maxBulkSizeExceededText: string;
    readonly maxSelectionSizeText: string;
    readonly selectionSizeText: string;
    readonly totalCount?: number;
};

export const BulkStatusMaxSizeErrorMessage: FunctionComponent<BulkStatusMaxSizeErrorMessageProps> = ({
    maxBulkSizeExceededText,
    maxSelectionSizeText,
    selectionSizeText,
    totalCount,
}) => (
    <div className="alert alert-danger width-100pct space-y-10">
        <div className="display-flex gap-10">
            <span className="text-color-danger text-size-h4 rioglyph rioglyph rioglyph-error-sign" />
            <div>
                <strong className="text-size-16">{maxBulkSizeExceededText}</strong> {maxSelectionSizeText}{' '}
                {totalCount !== undefined && (
                    <span>
                        {selectionSizeText} {totalCount}
                    </span>
                )}
            </div>
        </div>
    </div>
);
